import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CreateShippingViewModel(logout) {
  const { showSuccess } = useToast();
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [orders, setOrders] = useState([]);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [shipping, setShipping] = useState({
    id: 0,
    user_id: 0,
    orderItems: [],
    order_picked: 0,
  });

  const getOpenOrdersForDropdown = async function () {
    let callResult = await makePostApiCall(`getOpenOrdersForDropdown`);
    if (callResult.success) {
      setOrders(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onFetchOrderItems = async function (id) {
    let callResult = await makePostApiCall(`fetchOrder/${id}`);
    if (callResult.success) {
      const order = callResult.data;
      setShipping({
        ...shipping,
        order_id: order.id,
        customer: order.customer,
        orderItems: [...order.order_items],
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const createShippingApiCall = async function (newShipping) {
    let callResult = await makePostApiCall(`createShipping`, newShipping);
    if (callResult.success) {
      window.location = `/shippings/${callResult.data.id}`;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onFetchItemByBarcode = async function (scannedBarcode) {
    let callResult = await makePostApiCall(
      `fetchItemByBarcode/${scannedBarcode}`
    );
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    return callResult;
  };

  const getUsersForDropdown = async function (type, department) {
    const payload = { department: department, type: type };
    let callResult = await makePostApiCall(`usersForDropdown`, payload);

    if (callResult.success) {
      setEmployeeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    orders,
    getOpenOrdersForDropdown,
    onFetchOrderItems,
    loading,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    createShippingApiCall,
    shipping,
    onFetchItemByBarcode,
    setShipping,
    employeeOptions,
    getUsersForDropdown,
  };
}
